import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React from "react";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { AccordianStyled } from "./accordian.styles";
import classNames from "classnames";

const Accordian = (props) => {
  const {
    name,
    expanded,
    handleChange,
    heading,
    body,
    variant,
    arrowPosition = "left",
    dragHandleProps, // new prop for drag handle
    showDragHandle = false, // toggle drag handle visibility
  } = props;
  const isExpandable = Boolean(body);

  return (
    <AccordianStyled
      isExpandable={isExpandable}
      variant={variant}
      arrowPosition={arrowPosition}
    >
      <Accordion
        expanded={isExpandable && expanded === name}
        onChange={() =>
          expanded === name ? handleChange("") : handleChange(name)
        }
        className={classNames({ expanded: isExpandable && expanded === name })}
      >
        <AccordionSummary
          expandIcon={
            isExpandable ? (
              <ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />
            ) : null
          }
        >
          {/* Render the drag handle icon if requested */}
          {showDragHandle && dragHandleProps && (
            <div {...dragHandleProps} className="drag">
              <DragIndicatorIcon />
            </div>
          )}
          <div className="heading">{heading}</div>
        </AccordionSummary>
        {isExpandable ? <AccordionDetails>{body}</AccordionDetails> : null}
      </Accordion>
    </AccordianStyled>
  );
};

export default Accordian;
